import { render } from "./ResizeVolume.vue?vue&type=template&id=61b67498&scoped=true"
import script from "./ResizeVolume.vue?vue&type=script&lang=js"
export * from "./ResizeVolume.vue?vue&type=script&lang=js"

import "./ResizeVolume.vue?vue&type=style&index=0&id=61b67498&lang=scss&scoped=true"

import exportComponent from "/root/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b67498"]])

export default __exports__